import { useCallback, useState } from "react";

import EmployeeInfoContactInfo from "../pages/EmployeeInfoContactInfo";
import EmployeeInfoEducation from "../pages/EmployeeInfoEducation";
import EmployeeInfoFamily from "../pages/EmployeeInfoFamily";
import EmployeeInfoGeneralInfo from "../pages/EmployeeInfoGeneralInfo";
import EmployeeInfoWorkExperience from "../pages/EmployeeInfoWorkExperience";

import { MOCK_EDUCATION_LIST } from "../data/employeeInfo";

import { useTranslation } from "react-i18next";
import { EMPLOYEE_INFO_PAGE } from "../schemas/employeeInfoSchema";

function useEmployeeInfo() {
  const [selectedMenu, setMenu] = useState(EMPLOYEE_INFO_PAGE.GENERAL_INFO);
  const { t, i18n } = useTranslation();


  const getPage = useCallback(() => {
    switch (selectedMenu) {
      case EMPLOYEE_INFO_PAGE.GENERAL_INFO:
        return <EmployeeInfoGeneralInfo />;
      case EMPLOYEE_INFO_PAGE.CONTACT_INFO:
        return <EmployeeInfoContactInfo />;
      case EMPLOYEE_INFO_PAGE.FAMILY:
        return <EmployeeInfoFamily />;
      case EMPLOYEE_INFO_PAGE.WORK_EXPERIENCE:
        return <EmployeeInfoWorkExperience />;
      case EMPLOYEE_INFO_PAGE.EDUCATION:
        return <EmployeeInfoEducation educationList={MOCK_EDUCATION_LIST} />;
      default:
        return <div />;
    }
  }, [selectedMenu, i18n]);

  const handleMenuChange = useCallback(
    (e) => {
      setMenu(e);

    },
    [setMenu]
  );

  return { getPage, handleMenuChange };
}

export default useEmployeeInfo;
